import { useSmallScreen } from '@/hooks/useWindowDimension';
import classes from './CriticalTreesLegend.module.css';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';

export const CriticalTreesLegend = () => {
  const isSmallScreen = useSmallScreen();
  return (
    <div
      className={`${legendClasses.legend} ${classes.layout}`}
      data-testid="critical-trees-legend"
    >
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle}>Tree crowns</div>
      )}
      <div>
        <span
          className={`${classes.indicator} ${classes.indicatorCritical}`}
          data-testid="critical-trees-indicator"
        />
        Critical tree
      </div>
      <div>
        <span
          className={`${classes.indicator} ${classes.indicatorRoW}`}
          data-testid="critical-trees-indicator"
        />
        Other tree in RoW
      </div>
    </div>
  );
};
